import { getBackgroundImageOptions } from "@circle-react-shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import type { DefaultBlockStyles } from "../Homepage/constants";

export const salesPrimaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-primary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const salesSecondaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-secondary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const salesTertiaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor:
    "var(--theme-website-primary-button-default-background-color)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const getSalesBlockPrimaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: salesPrimaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: salesPrimaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: salesPrimaryBlockDefaultStyles.margin,
  }),
});

export const getSalesBlockSecondaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: salesSecondaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: salesSecondaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: salesSecondaryBlockDefaultStyles.margin,
  }),
});

export const getSalesBlockTertiaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: salesTertiaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: salesTertiaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: salesTertiaryBlockDefaultStyles.margin,
  }),
});
